<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="row" style="margin-bottom: 5px">
      <div class="col">
        <b-button-group>
          <b-button
            style="font-size: 12px; padding: 5px"
            variant="link"
            :disabled="currentSelectedItem == null"
            @click="updateItem()"
          >
            <svg
              height="24px"
              width="24px"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <title>{{ $store.state.localization.data.common.updateLabel }}</title>
              <path
                style="fill: #dd539c"
                d="M505.842,130.44L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.495L239.856,114.905
	l32.955,32.955l45.663,45.665l45.665,45.661l32.955,32.955L503.35,165.889C513.827,155.412,514.944,139.539,505.842,130.44z"
              />
              <path
                style="fill: #efc377"
                d="M85.444,426.555L6.828,347.934c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312v68.969
	c0,6.438,2.61,12.262,6.825,16.478c4.218,4.215,10.044,6.825,16.478,6.825h68.966l55.314,0.002c6.182,0,12.11-2.458,16.478-6.825
	L85.444,426.555z"
              />
              <polygon
                style="fill: #f4d944"
                points="364.141,239.189 318.475,193.525 272.812,147.863 239.858,114.905 6.828,347.934 
	85.444,426.555 164.064,505.175 397.094,272.141 "
              />
              <path
                style="fill: #ecb555"
                d="M0.003,488.693c0,6.439,2.61,12.262,6.825,16.478l78.617-78.617L6.828,347.934
	c-4.373,4.373-6.825,10.295-6.828,16.48l0.003,55.312V488.693z"
              />
              <polygon
                style="fill: #f1cc30"
                points="318.475,193.525 272.813,147.863 239.858,114.905 6.828,347.934 85.444,426.555 "
              />
              <path
                style="fill: #db348a"
                d="M318.475,193.525L443.7,68.299L381.559,6.158c-9.099-9.101-24.973-7.982-35.449,2.493
	L239.856,114.905l32.955,32.955L318.475,193.525z"
              />
            </svg>
          </b-button>
        </b-button-group>
      </div>
    </div>

    <div class="row" style="height:100%;">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          selectable
          select-mode="single"
          :items="guns"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="itemClicked"
          v-bind:sticky-header="clientHeight"
        >
          <template #cell(fuelDepo)="data">
            {{ formatFuelDepo(data.item.fuelDepoId) }}
          </template>
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template>
            <span class="text-success"></span>
          </template>
        </b-table>
      </div>
    </div>
      <UpdateGunPage
        v-bind:gun="currentSelectedItem"
        v-on:gunUpdatedSuccessEvent="gunUpdatedSuccessEvent"
        v-on:gunUpdatedFailEvent="gunUpdatedFailEvent"
        ref="update-item-page"
    ></UpdateGunPage>
  </div>
</template>

<script>
import UpdateGunPage from "../UpdateGun/UpdateGunPage.vue";

export default {
  name: "ListGunsPage",
  components: {
    UpdateGunPage,
  },
  props: {
    users: Array,
    trks: Array,
    fuelDepos: Array,
  },
  data() {
    return {
      currentSelectedItem: null,
      guns: []
    };
  },
  watch: {
    combinedWatch: {
      immediate: true,
      handler([trks]) {
        if (!Array.isArray(trks) || trks.length === 0) return;

        this.guns = [];

        for (let i = 0; i < this.trks.length; i++) {
          if (!this.trks[i].guns) {
            continue;
          }
          for (let j = 0; j < this.trks[i].guns.length; j++) {
              this.guns.push({
                  id: this.trks[i].guns[j].id,
                  fuelDepoId: this.trks[i].fuelDepoId,
                  trk: this.trks[i].name,
                  trkNumber: this.trks[i].guns[j].trkNumber,
                  pumpSerialMedoc: this.trks[i].guns[j].pumpSerialMedoc,
                  totalCounters: this.trks[i].guns[j].totalCounters,
                  clientId: this.trks[i].guns[j].clientId,
                  userId: this.trks[i].guns[j].userId,
                  created: this.trks[i].guns[j].created,
                  updated: this.trks[i].guns[j].updated,
                  executor: this.trks[i].guns[j].executor
              });
          }
        }
      }
    }
  },
  computed: {
    combinedWatch() {
      return [this.trks];
    },
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.azk.guns
          .tableColumns) {
            if (
              key == "id" ||
              key == "fuelDepo" ||
              key == "trk" ||
              key == "trkNumber"
            ) {
              headers.push({
                key: key,
                label:
                  this.$store.state.localization.data.mainPage.azk.guns.tableColumns[
                    key
                  ],
                sortable: true,
                thClass: "textMiddle",
              });
            }
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  created() {
    this.guns.clear();

    for (let i = 0; i < this.trks.length; i++) {
        for (let j = 0; j < this.trks[i].guns.length; j++) {
            this.guns.push({
                id: this.trks[i].guns[j].id,
                fuelDepoId: this.trks[i].fuelDepoId,
                trkName: this.trks[i].name,
                trkNumber: this.trks[i].guns[j].trkNumber,
                totalCounters: this.trks[i].guns[j].totalCounters,
                created: this.trks[i].guns[j].created,
                updated: this.trks[i].guns[j].updated
            });
        }
    }
  },
  methods: {
    itemClicked(row) {
      this.currentSelectedItem = row;
    },
    async updateItem() {
      this.$refs["update-item-page"].open();
    },
    formatFuelDepo(fuelDepoId) {
      for (let i = 0; i < this.fuelDepos.length; i++) {
        if (
          this.fuelDepos[i].id == fuelDepoId
        ) {
          return this.fuelDepos[i].name;
        }
      }

      return "";
    },
    gunUpdatedSuccessEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateSuccess.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.guns.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
    gunUpdatedFailEvent() {
      this.currentSelectedItem = null;
      alert(this.$store.state.localization.data.common.entityUpdateError.replace("[ENTITY_NAME]", this.$store.state.localization.data.mainPage.azk.guns.pageLabel));
      this.$emit("itemUpdatedEvent");
    },
  },
};
</script>
